import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "./styles";
import src from "@/assets/images/flavor_color_crop.png";

const FlavorwikiHeader = () => {
  return (
    <Link to="/">
      <Icon style={{ backgroundImage: `url(${src})` }} />
    </Link>
  );
};

export default FlavorwikiHeader;
